// extracted by mini-css-extract-plugin
export default {"modify_order_header":"RB","center":"SB","empty":"TB","pending":"UB","referralTitle":"VB","wrapper":"WB","title":"XB","tabs":"YB","tab":"ZB","active":"aC","btn":"bC","rewards_table":"cC"};
    if(module.hot) {
      // 1721922364124
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  